module.exports = __webpack_public_path__ + "static/media/return-date-icon.54dd42bd.svg";